import axios from 'axios';

const DOMINIO_INSIDE = '@insidesistemas.com.br';
const DESLOCAMENTO_SENHA_ORACULO = 23;
const DIGITOS_UNIDADE = 4;

export class CredencialInvalidaError extends Error {
  constructor() {
    super('E-mail ou senha inválidos.');
    this.name = 'CredencialInvalidaError';
  }
}

export class UnidadeIndisponivelError extends Error {
  constructor(unidade: string) {
    super(`Não foi possível conectar à unidade ${unidade}. Verifique com o suporte.`);
    this.name = 'UnidadeIndisponivelError';
  }
}

export function isEmailInside(email: string): boolean {
  return email.trim().toLowerCase().endsWith(DOMINIO_INSIDE);
}

export function isEmailValido(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function formatarUnidade(unidade: string | number): string {
  return String(unidade).trim().padStart(DIGITOS_UNIDADE, '0');
}

export function codificarSenhaOraculo(senha: string): string {
  const bytes = new TextEncoder().encode(senha);
  const deslocados = bytes.map((byte) => (byte + DESLOCAMENTO_SENHA_ORACULO) % 256);

  return new TextDecoder('windows-1252').decode(deslocados);
}

export async function obterUnidadePeloOraculo(email: string, senha: string): Promise<string> {
  const urlOraculo = process.env.REACT_APP_ORACULO;

  if (!urlOraculo) throw new Error('A variável REACT_APP_ORACULO não está configurada.');

  let resposta;

  try {
    resposta = await axios.post(
      `${urlOraculo}/api/v1/OsMobile/ValidaContato`,
      { email, senha: codificarSenhaOraculo(senha) },
      { headers: { 'private-token-osmobile': 'private-token-osmobile' } }
    );
  } catch (error: any) {
    const status = error?.response?.status;

    if (status === 402 || status === 404) throw new CredencialInvalidaError();

    throw error;
  }

  const unidade = resposta?.data?.Unidade;

  if (!unidade) throw new Error('O Oráculo não devolveu a unidade do contato.');

  return String(unidade);
}

export async function obterIdSessaoDaUnidade(unidade: string): Promise<string> {
  let idSessao: string | undefined;

  try {
    const resposta = await axios.get(`${process.env.REACT_APP_API_HUBBY}/idsessao`, {
      params: { unidade },
    });

    idSessao = resposta?.data?.data?.idSessao;
  } catch (error) {
    throw new UnidadeIndisponivelError(unidade);
  }

  if (!idSessao) throw new UnidadeIndisponivelError(unidade);

  return idSessao;
}
